import React from 'react';

import { useTranslation } from 'react-i18next';

import PropertyComponent from 'components/builder/properties/input/Property';
import { H4 } from 'components/typography';

import { ChannelIntegrationEditorProps } from './ChannelIntegrationEditorProps';

import styles from './YardiIntegrationEditor/YardiIntegrationEditor.scss';

export const ControlByWeb = ({
  channelIntegration,
  onUpdateChannelIntegration,
  definition,
  channel,
}: ChannelIntegrationEditorProps) => {
  const { t } = useTranslation();
  const settings = channelIntegration?.settings;
  const properties = definition?.properties;
  const isPrefixEnabled = (
    properties: any,
    settings: any,
    key: string
  ): boolean => {
    const syncPastUsersProperty = properties[key];

    if (!syncPastUsersProperty) {
      return false;
    }

    const { enablePrefix } = settings || {};

    if (enablePrefix) {
      properties.prefix_filter.validators.push(
        {
          name: 'Required',
          value: true,
        },
        {
          name: 'Min',
          value: 1,
        }
      );

      return true;
    }

    if (properties?.prefix_filter?.validators.length) {
      properties.prefix_filter.validators = [];
    }

    return false;
  };

  return (
    <>
      <H4 mb={4}>{t('web-admin-integrations-controlbyweb-settings-header')}</H4>
      <div>
        {Object.entries(properties).map(([key, property]) => {
          if (
            ['prefix_filter'].includes(key) &&
            !isPrefixEnabled(properties, settings, key)
          ) {
            return null;
          }

          channelIntegration.settings.prefix_filter = `${channel._id}::::`;

          return (
            <div key={key}>
              <div className={styles.property}>
                {/* @ts-expect-error ts-migrate(2739) FIXME: Type '{ property: PropertyType<PropertyOptionType>... Remove this comment to see the full error message */}
                <PropertyComponent
                  object={channelIntegration.settings}
                  channel={channel}
                  label={property.friendlyName || property.name || key}
                  property={property}
                  propertyKey={key}
                  disabled={key === 'prefix_filter'}
                  value={channelIntegration.settings?.[key]}
                  onChange={(value: any) =>
                    onUpdateChannelIntegration({
                      settings: {
                        ...channelIntegration.settings,
                        [key]: value,
                      },
                    })
                  }
                />
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
